import { type DocumentNode, gql } from '@apollo/client';

export const REPORT_TYPE_OPTIONS = [
  { name: 'RSM', value: 'rsm' },
  { name: 'ICB', value: 'icb' },
  { name: 'ICM', value: 'icm' },
  { name: 'FICM', value: 'ficm' }
] as const;

export const GET_SELECTION_FIELDS = gql`
  query SelectionFields {
    layoutTypes: getFieldSelections(
      model: "opstream.deal.opportunity.appendix"
      fieldName: "layout_type"
    ) {
      id
      name
      value
    }
  }
`;

export const GET_APPENDICES = gql`
  query Appendices($dealId: ID!) {
    appendices(dealOpportunityId: $dealId) {
      appendixType
      hidden
      id
      image
      image2
      layoutType
      reportTypeCodes
      sequence
      text
      text2
      text3
      text4
      textHeader1
      textHeader2
      textHeader3
      title
    }
  }
`;

export const CREATE_APPENDIX = gql`
  mutation CreateAppendix($dealOpportunityId: ID!, $values: AppendixInput!) {
    createAppendix(dealOpportunityId: $dealOpportunityId, values: $values) {
      ok
      errors
    }
  }
`;

export const UPDATE_APPENDIX: DocumentNode = gql`
  mutation UpdateAppendix(
    $id: ID!
    $title: String
    $hidden: Boolean
    $sequence: Int
    $layoutType: String
    $reportTypeCodes: [String]
    $text: String
    $text2: String
    $text3: String
    $text4: String
    $textHeader1: String
    $textHeader2: String
    $textHeader3: String
    $image: String
    $image2: String
  ) {
    updateAppendix(
      id: $id
      values: {
        title: $title
        hidden: $hidden
        sequence: $sequence
        layoutType: $layoutType
        reportTypeCodes: $reportTypeCodes
        text: $text
        text2: $text2
        text3: $text3
        text4: $text4
        textHeader1: $textHeader1
        textHeader2: $textHeader2
        textHeader3: $textHeader3
        image: $image
        image2: $image2
      }
    ) {
      ok
      errors
    }
  }
`;

export const DELETE_APPENDIX = gql`
  mutation DeleteAppendix($id: ID!) {
    deleteAppendix(id: $id) {
      ok
      message
    }
  }
`;

export const LAYOUT_TYPE_FIELDS = {
  comment_left_image_right: ['text', 'image'],
  comment_top_image_bottom: ['text', 'image'],
  comment_top_text_bottom: ['text', 'text_2'],
  image_left_image_right: ['image', 'image_2'],
  image_left_text_right: ['image', 'text'],
  image_left_three_comments_right: ['image', 'text', 'text_2', 'text_3'],
  image_top_comment_bottom: ['image', 'text'],
  image_top_split_bottom: ['image', 'image_2', 'text'],
  image_top_two_comments_bottom: ['image', 'text', 'text_2'],
  recent_project: ['image', 'image_2', 'text'],
  single_image: ['image'],
  text_left_image_right: ['text', 'image'],
  text_only: ['text'],
  text_top_image_bottom: ['text', 'image'],
  text_top_images_bottom: [
    'text',
    'text_2',
    'image',
    'image_2',
    'text_header_1',
    'text_header_2'
  ],
  text_top_three_comments_bottom: [
    'text',
    'text_2',
    'text_3',
    'text_4',
    'text_header_1',
    'text_header_2',
    'text_header_3'
  ],
  text_top_two_images_bottom: ['text', 'image', 'image_2'],
  two_columns_comment_right: ['image', 'image_2', 'text']
} as const;

export type DynamicFieldKey =
  (typeof LAYOUT_TYPE_FIELDS)[keyof typeof LAYOUT_TYPE_FIELDS][number];
export type LayoutTypeValue = keyof typeof LAYOUT_TYPE_FIELDS;
